<template>
  <div class="flex flex-col gap-1.5 text-center">
    <div
      class="w-10 h-10 p-3 rounded-lg flex-col justify-center items-center gap-2.5 inline-flex border-2 text-text-secondary"
      :class="{
        'border-border-brand bg-surface': priority === 'normal',
        'border-border-warning bg-fill-warning-secondary]':
          priority === 'incoming',
        'border-border-critical bg-fill-critical-secondary':
          priority === 'urgent',
      }"
    >
      <div
        class="text-center text-xl font-normal font-serif uppercase"
        :class="{ 'text-white/60': expired && priority === 'normal' }"
      >
        {{ counter > 0 ? padCounter : "00" }}
      </div>
    </div>

    <div class="text-basics-tertiary-60 text-xs font-serif">
      {{ label }}
    </div>
  </div>
</template>

<script setup lang="ts">
import type { CardPriority } from "./creation/contests";
import { padNumber } from "@/utils/date";
import { computed } from "vue";

const props = defineProps<{
  counter: number;
  label: string;
  priority: CardPriority;
  expired: boolean;
}>();

const padCounter = computed(() => padNumber(props.counter));
</script>
